import React, { useEffect, useRef, useState } from "react";
import Icons from "../../../../Config/Images";
import "./MyAccountSideBar.css"; // External CSS
import { BASE_URL } from "../../../../Constants/AppConstants";
import { useDispatch, useSelector } from "react-redux";
import { UploadMediaRequestAPI } from "../../../../Store/Action/mediaAction";
import {
  getLoggedInUserDetailsAPI,
  logOutUserAPI,
  updateUserAPI,
} from "../../../../Store/Action/UserAction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../../Store/Slice/authSlice";
import { logoutUser } from "../../../../Store/Slice/UserSlice";
import { resetOnboardingFlag } from "../../../../Store/Slice/onboardingSlice";
import persistStore from "redux-persist/es/persistStore";
import { store } from "../../../../Store";
import LogoutModal from "../MyAccount/CustomModals/LogoutModal";
import { Switch } from "@mui/material";
import {
  createGenericDataAPI,
  getGlobalGenericNameAPI,
} from "../../../../Store/Action/globalAction";
import { setWastage } from "../../../../Store/Slice/wastageSlice";
import { getRewardPointUnitsAPI } from "../../../../Store/Action/rewardPointsAction";
import {
  clearRewardPointUnitId,
  setRewardPointUnitId,
} from "../../../../Store/Slice/rewardPointSlice";
import { compressImage } from "../../../../Utils/imageCompression";

const MyAccountSidebar = ({ isAccountSideBarOpen, toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const sidebarRef = useRef(null);

  const [loggedInUser, setLoggedInUser] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const [genericTypeId, setGenericTypeId] = useState();
  const [wastageEnabled, setWastageEnabled] = useState(false);
  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled
  );
  const [unitCards, setUnitCards] = useState([]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (userResult) => {
        const newStatus =
          userResult?.data?.[0]?.user_generic_data_value?.[0]
            ?.user_generic_data_boolean_value;

        if (typeof newStatus === "boolean") {
          dispatch(setWastage(newStatus)); // Store in Redux
        }
      })
    );
  }, [dispatch]);

  const accountCards = [
    { img: Icons.manage_profile_image, label: "Manage Profile" },
    { img: Icons.my_order_image, label: "My Orders" },
    { img: Icons.my_order_image, label: "Pre Orders" },
    { img: Icons.my_address_img, label: "My Address" },
    { img: Icons.wallet_image, label: "Wallet" },
    { img: Icons.reward_point_image, label: "Reward Points" },
    { img: Icons.my_subscription_image, label: "My Subscription" },
    { img: Icons.share_image, label: "Share" },
    { img: Icons.tANDc_image, label: "Terms & Conditions" },
    // { img: Icons.live_rate_icon, label: "Live Rate" },
    // { img: Icons.live_rate_2, label: "Live Rate" },
    // { img: Icons.logoutIcon, label: "log out" },
  ];

  // Close sidebar when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
  //       setIsOpen(false);
  //       toggleSidebar();
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Ignore clicks on the scrollbar (usually ~15-17px from the right edge)
      const isClickOnScrollbar = event.clientX >= window.innerWidth - 20; // adjust 20 based on your OS/browser

      if (isClickOnScrollbar) return;

      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
        toggleSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setLoggedInUser(result?.data?.[0]);
      })
    );
  }, [dispatch]);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // Compress here
      const compressedFile = await compressImage(file);
      setSelectedFile(file);
      handleUpload(file);
    }
  };

  const handleUpload = (file) => {
    // const driveName = "profile_photos";
    const driveName = "userProfile";
    const isMultiple = false;

    dispatch(
      UploadMediaRequestAPI([file], driveName, isMultiple, (result) => {
        const requestData = {
          user_profile_image_id: result?.data?.[0]?.file_storage_id,
        };
        if (result?.status) {
          dispatch(
            updateUserAPI(requestData, (result2) => {
              if (result2?.status) {
                // toast.success(result2?.message?.message);
                dispatch(
                  getLoggedInUserDetailsAPI({}, (result) => {
                    setLoggedInUser(result?.data?.[0]);
                  })
                );
              }
            })
          );
        } else {
          toast.error("Failed to upload profile photo.");
        }
      })
    );
  };

  useEffect(() => {
    dispatch(
      getRewardPointUnitsAPI({}, (result) => {
        setUnitCards(result?.data || []);
      })
    );
  }, [dispatch]);

  const handleClick = (card) => {
    // Normalize the label for the navigation path
    const normalizedLabel = card.label.toLowerCase().replaceAll(" ", "-");

    if (card?.label === "Log Out") {
      setIsModalOpen(true); // Open the modal
    } else if (card?.label === "Terms & Conditions") {
      navigate(`/my-account/terms-and-conditions`); // Navigate to Terms & Conditions page
    } else if (card?.label === "Reward Points") {
      if (unitCards?.length == 1) {
        dispatch(clearRewardPointUnitId());
        dispatch(
          setRewardPointUnitId(Number(unitCards?.[0]?.reward_point_unit_id))
        );
        navigate(`/my-account/reward-points`, {
          state: {
            rewardPointUnitId: Number(unitCards?.[0]?.reward_point_unit_id),
          },
        });
      } else {
        navigate(`/my-account/start-reward-points`);
      }
    } else {
      navigate(`/my-account/${normalizedLabel}`);
    }
  };

  const loggedInUserCall = () => {
    dispatch(getLoggedInUserDetailsAPI({}, (result) => {}));
  };

  const handleCloseModal = () => {
    setIsLogoutOpen(false);
  };

  const handleLogOut = () => {
    dispatch(
      logOutUserAPI({}, (result) => {
        if (result?.status) {
          dispatch(logout());
          dispatch(logoutUser());
          dispatch(resetOnboardingFlag());
          persistStore(store).purge(); // Clears `persist:root` from local storage
          localStorage.removeItem("persist:root"); // Force remove persisted state
          localStorage.removeItem("userId"); // Force remove user
          localStorage.removeItem("startTime"); // Force remove start timer
          localStorage.removeItem("flagOnboarded"); // Force remove flag onboarded flag
          localStorage.removeItem("isRefillingOnboardingFormIsNowInReviewed");
          localStorage.removeItem("cameFromHomeClick");
          localStorage.removeItem("subscriptionPreviewTimer");
          toast.success(result?.data?.message);
          loggedInUserCall();
          setTimeout(() => {
            navigate("/home", { replace: true }); // Ensure navigation happens after API call
          }, 500); // Added delay to ensure function executes
        }

        setIsLogoutOpen(false);
      })
    );
  };

  useEffect(() => {
    dispatch(
      getGlobalGenericNameAPI({}, (result) => {
        if (result && Array?.isArray(result)) {
          const userShopNameInfo = result?.find(
            (item) => item?.generic_data_type_name === "wastage"
          );
          setGenericTypeId(userShopNameInfo?.generic_data_type_id || null);
        }
      })
    );
  }, [dispatch]);

  const handleWastageToggle = () => {
    const requestData = {
      user_generic_type_id: genericTypeId || 1,
    };
    try {
      dispatch(
        createGenericDataAPI(requestData, (isSuccess, result) => {
          if (isSuccess?.status === true) {
            // toast.success(result?.data?.message);
            // Update the UI immediately to reflect the change
            // setWastageEnabled((prev) => !prev); // Toggle the wastageEnabled state
            // Fetch updated status from API
            dispatch(
              getLoggedInUserDetailsAPI({}, (userResult) => {
                if (userResult?.data?.[0]?.user_generic_data_value?.[0]) {
                  const newStatus =
                    userResult.data[0].user_generic_data_value[0]
                      .user_generic_data_boolean_value;

                  dispatch(setWastage(newStatus)); // Store in Redux
                }
              })
            );
          } else {
            toast.error(result?.error?.message);
          }
        })
      );
    } catch (error) {
      toast.error("somethingWentWrongError");
    }
  };

  // useEffect(() => {
  //   dispatch(
  //     getLoggedInUserDetailsAPI({}, (result) => {
  //       setWastageEnabled(
  //         result?.data?.[0]?.user_generic_data_value[0]
  //           ?.user_generic_data_boolean_value
  //       );
  //     })
  //   );
  // }, []);
  return (
    isOpen && (
      <>
        <div
          ref={sidebarRef}
          className={`account-sidebar ${
            isAccountSideBarOpen ? "open" : "closed"
          }`}
        >
          <div style={{ position: "relative" }}>
            <button
              className="close-btn-account-sidebar"
              onClick={toggleSidebar}
            >
              ✖
            </button>

            {/* User Profile Section */}
            <div className="account-header-account">
              {/* <img className="profile-icon" src={Icons.profileIcon} alt="User" /> */}
              <div className="profile-picture">
                {/* <img src={Icons.profile_picture_image} alt="Profile" /> */}
                <img
                  className="user-image"
                  src={
                    loggedInUser?.image
                      ? `${BASE_URL}${loggedInUser.image}`
                      : Icons.default_image
                  }
                  alt="Profile"
                  onClick={() => document.getElementById("fileInput").click()} // Open file input on click
                />
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <div className="camera-pic-image-div">
                  <img
                    className="camera-pic"
                    src={Icons.camera_profile_image}
                    alt=""
                    onClick={() => document.getElementById("fileInput").click()} // Open file input on click
                  />
                </div>
              </div>
              <div className="user-info">
                <h4 className="user-name">{loggedInUser?.user_first_name}</h4>
                <p className="user-phone-account">
                  {loggedInUser?.user_mobile_number}
                </p>
              </div>
            </div>
            <div className="logout-section">
              <div
                className="account-item-logout"
                // onClick={() => setIsLogoutOpen(true)}
              >
                <Switch
                  // checked={wastageEnabled === true ? true : false}
                  checked={isWastageEnabled}
                  onChange={handleWastageToggle}
                  sx={{
                    "& .MuiSwitch-track": {
                      background:
                        "linear-gradient(180deg, #E8EAEA 0%, #FFFFFF 100%)", // Light gradient for unchecked state
                      opacity: 1,
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      background:
                        "linear-gradient(180deg, #B88A35 0%, #855E2A 100%)", // Golden gradient for checked state
                      opacity: 1,
                    },
                    "& .MuiSwitch-thumb": {
                      background:
                        "linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%)", // Light gradient for thumb in unchecked state
                    },
                    "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
                      background: "#FFFFFF", // Solid white for thumb when checked
                    },
                  }}
                />
                <span style={{ color: "#181818" }} className="label">
                  Wastage
                </span>
              </div>
            </div>
            {/* Account Menu */}
            <div className="account-menu">
              {accountCards.map((card, index) => (
                <div
                  className="account-item"
                  key={index}
                  onClick={() => handleClick(card)}
                >
                  <img className="icon" src={card.img} alt={card.label} />
                  <span className="label">{card.label}</span>
                </div>
              ))}
            </div>

            {/* Logout Section */}
            <div className="logout-section">
              <div
                className="account-item-logout"
                onClick={() => setIsLogoutOpen(true)}
              >
                <img
                  className="icon"
                  src={Icons.logout_red_icon}
                  alt="Logout"
                />
                <span className="label">Log Out</span>
              </div>
            </div>
            {isLogoutOpen && (
              <LogoutModal onClose={handleCloseModal} onLogOut={handleLogOut} />
            )}
          </div>
        </div>
      </>
    )
  );
};

export default MyAccountSidebar;
